import { isDevEnvironment } from './environment'

function isTruthyEnvFlag(value: string | undefined): boolean {
  if (!value) return false
  const normalized = value.trim().toLowerCase()
  return normalized === 'true' || normalized === '1'
}

/** Dev-only: show Graftcode onboarding on every visit (ignores completion cookies). */
export function isForceGraftcodeOnboardingEnabled(): boolean {
  if (!isDevEnvironment()) return false

  const flag = process.env.NEXT_PUBLIC_FORCE_GRAFTCODE_ONBOARDING ?? process.env.NEXT_PUBLIC_FORCE_PORTAL_ONBOARDING

  return isTruthyEnvFlag(flag)
}
